import { date } from 'utils/date/date';
import { errorNotifier } from 'utils/errorNotifier/errorNotifier';
import clientValidate from 'validate.js';
import XRegExp from 'xregexp';

const dateFormat = 'MM/DD/YYYY';
const dateRegExp = /^\d{2}\/\d{2}\/\d{4}$/;

clientValidate.extend(clientValidate.validators.datetime, {
  parse: function (value: any, _options: any) {
    if (!value) {
      return false;
    }
    if (!dateRegExp.test(value)) {
      return true;
    }

    return date.utc(value, dateFormat);
  },
  format: function (value: any, _options: any) {
    return date.utcFormat(value, dateFormat);
  },
});

clientValidate.validators.customFormat = (value: any, options: any) => {
  if (!value) {
    return;
  }

  try {
    const { pattern } = options;
    const ignoreCase = pattern.includes('(?i)');
    const patternStr = pattern
      .replace(/\\A/i, '^')
      .replace(/\\Z/i, '$')
      .replace(/\(\?i\)/g, '');

    const regExp = new XRegExp(patternStr, ignoreCase ? 'i' : undefined);
    const message = options.message || '^is invalid';

    if (regExp.test(value)) {
      return;
    }

    return message;
  } catch (error) {
    errorNotifier.notify(error);
  }
};

export { clientValidate };
